<template>
    <div class="persondata-center">
        <div class="center-top">
            <div class="center-left">
                <img class="user-img" :src="userImg ? userImg : userImgMoren" alt="">
                <div class="user-detail">
                    <p class="user-detail-name">
                        {{ username }}
                    </p>
                    <div class="user-detail-account">
                        账号：{{ phone }}
                    </div>
                </div>
            </div>
            <div class="center-right">
                <div class="bind-wx">
                    <img :src="wxIcon" alt="">
                    <div class="bind-wx-box">
                        <div class="bind-wx-title">微信绑定</div>
                        <div class="bind-wx-bot">
                            <span class="bind-wx-status">未绑定</span>
                            <!--                            <span class="bind-wx-edit">修改</span>-->
                        </div>
                    </div>
                </div>

                <div class="bind-wx">
                    <img :src="telIcon" alt="">
                    <div class="bind-wx-box">
                        <div class="bind-wx-title">手机号绑定</div>
                        <div class="bind-wx-bot">
                            <span class="bind-wx-status">已绑定</span>
                            <span class="bind-wx-bind" @click="changeBindTel()">修改</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--最新订单-->
        <div class="new-order">
            <div class="new-order-top">
                <span class="new-order-line"></span>
                <span class="new-order-span">最新订单</span>
            </div>
            <div class="new-order-list">
                <div class="new-order-list-area" v-for="(item,index) in orderList" :key="index">
                    <img class="order-area-img" :src="item.imgUrl" alt="">
                    <div class="order-area-box">
                        <div class="order-area-top">
                            <p class="order-area-type">{{ item.type }}</p>
                            <div class="order-area-money">
                                <span class="order-area-money-num">¥ {{ item.money }}</span>
                                |
                                <span class="order-area-status">{{ item.status }}</span>
                            </div>
                        </div>

                        <div class="order-trip">
                            <span class="order-trip-start">{{ item.start }}</span>
                            <img src="@/assets/images/persondata/personal_icon_dao.png" alt="">
                            <span class="order-trip-start">{{ item.end }}</span>
                        </div>

                        <div class="order-trip-time">
                            <span class="order-trip-start-time">
                                出发日期：
                            </span>
                            <span class="order-trip-detail-time">
                                {{ item.time }}
                            </span>
                        </div>

                        <div class="order-trip-car">
                            <span class="order-trip-start-time">
                                车辆数目：
                            </span>
                            <span class="order-trip-detail-time">
                                {{ item.carNum }}
                            </span>
                        </div>
                    </div>
                </div>

                <p class="no-more-order">
                    没有更多订单
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "persondatahome",
        data() {
            return {
                userImg: '',
                userImgMoren: require('@/assets/images/persondata/morentouxiang.png'),
                wxIcon: require('@/assets/images/persondata/personal_icon_weixin.png'),
                telIcon: require('@/assets/images/persondata/personal_icon_shouji.png'),
                orderList: [],
                // orderList: [
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '出发城市出',
                //         end: '出发城市出发城市出发城市',
                //         time: '6月4号  9:00',
                //         carNum: '9'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '1222',
                //         end: '1222',
                //         time: '6月4号  9:00',
                //         carNum: '9'
                //     }
                // ],
                username: '',
                phone: '',
            }
        },
        methods: {
            myBaseInfo() {
                this.$axios.get("/myBaseInfo").then((res) => {
                    // console.log(res.data);
                    res = res.data;
                    if (res.status == 200) {
                        this.username = res.data.name;
                        this.phone = res.data.phone;
                        this.userImg = res.data.headUrl;
                    } else {
                        // layer.msg(res.msg, {icon: 2});
                        this.$message(res.msg);
                    }
                })
            },
            changeBindTel() {
                this.$router.push({path: 'binding'});
            }
        },
        mounted() {
            this.myBaseInfo();
        },
    }
</script>

<style scoped>
    .persondata-center {

    }

    .center-top {
        width: 998px;
        height: 140px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .center-left {
        width: 454px;
        height: 100px;
        border-right: 1px solid #eee;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .user-img {
        margin-left: 40px;
        width: 90px;
        height: 90px;
        border-radius: 50%;
    }

    .user-detail {
        margin-left: 30px;
        width: 280px;
        height: 100px;
        display: flex;
        flex-direction: column;
    }

    .user-detail-name {
        width: 280px;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 26px;
    }

    .user-detail-account {
        width: 280px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .center-right {
        width: 540px;
        height: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bind-wx {
        width: 270px;
        height: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bind-wx img {
        margin-left: 54px;
        width: 36px;
        height: 36px;
    }

    .bind-wx-box {
        margin-left: 10px;
        width: 170px;
        height: 40px;
    }

    .bind-wx-title {
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .bind-wx-bot {
        width: 100%;
        height: 20px;
        line-height: 20px;
    }

    .bind-wx-status {
        display: inline-block;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .bind-wx-edit {
        display: inline-block;
        padding: 0 5px;
        cursor: pointer;
        color: #13952B;
    }

    .bind-wx-bind {
        display: inline-block;
        padding: 0 5px;
        cursor: pointer;
        color: #FF5227;
    }

    .new-order {
        width: 1000px;
        margin-top: 16px;
    }

    .new-order-top {
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .new-order-line {
        width: 2px;
        height: 14px;
        background: #FF5227;
        margin-right: 10px;
    }

    .new-order-span {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .new-order-list {
        margin-top: 5px;
    }

    .new-order-list-area {
        width: 998px;
        height: 140px;
        border: 1px solid #EEEEEE;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-area-img {
        width: 150px;
        height: 112px;
        border-radius: 4px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .order-area-box {
        width: 770px;
        height: 112px;
    }

    .order-area-top {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
    }

    .order-area-type {
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .order-area-money {
        height: 24px;
        line-height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-area-money-num {
        color: #CF0000;
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        margin-right: 6px;
    }

    .order-area-status {
        color: #2577E3;
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        margin-left: 6px;
    }

    .order-trip {
        margin-top: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-trip-start {
        max-width: 240px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .order-trip img {
        width: 27px;
        height: 6px;
        margin-left: 18px;
        margin-right: 18px;
    }

    .order-trip-time, .order-trip-car {
        height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-trip-start-time {
        width: 70px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .order-trip-detail-time {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .no-more-order {
        width: 100%;
        height: 20px;
        line-height: 24px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/persondatahome.vue